import { render, staticRenderFns } from "./ClientBillingCard.vue?vue&type=template&id=81093be4&scoped=true&"
import script from "./ClientBillingCard.vue?vue&type=script&lang=js&"
export * from "./ClientBillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81093be4",
  null
  
)

export default component.exports